module.exports = __webpack_public_path__ + "5c9d8f16fb187d206040e159936271d0.fbx";